import React from 'react' 

// MATERIAL UI STUFF 
import Typography from '@material-ui/core/Typography'
 
 
export default class PortfolioTextPane extends React.Component { 
  render(){ 
    return( 
      <div className="MainDiv"> 
        <Typography style={{fontWeight: 500, opacity: 1, color: `${this.props.colorTitle}`}} gutterBottom variant="display1">{this.props.title}</Typography> 
        <Typography style={{fontWeight: 400, lineHeight: '1.2em', opacity: .8, color: `${this.props.colorSubtitle}`}} gutterBottom variant="headline">{this.props.subtitle}</Typography> 
        <a href={this.props.text} target='_blank' style={{textDecoration: 'none', color: `${this.props.colorText}`}}> 
        <Typography style={{opacity: .8, color: `${this.props.colorText}`}} variant="subheading">{this.props.text}</Typography> 
        </a> 
        <Typography style={{opacity: .8, color: `${this.props.colorText}`}} variant="subheading">{this.props.textNoLink}</Typography>  
      </div> 
      ) 
  } 
}   


// WEBPACK FOOTER //
// ./src/Components/Utilities/PortfolioTextPane.js